import Vue from 'vue';

const EventBus = new Vue({});

export { EventBus };

export default {
  install(VueInstance) {
    const instance = VueInstance;
    instance.prototype.$bus = EventBus;
  },
};
